import mateo from './Recursos/foto_mateo.png'
import florencia from './Recursos/foto_florencia.png'
import santiago from './Recursos/foto_santiago.png'
import lucia from './Recursos/foto_lucia.png'
import matias from './Recursos/foto_matias.png'

export const NUMWASS = '5491125870012'

export const SECCIONES = ['Catalogo', 'Testimonios', 'Blog']

export const TESTIMONIOS =
    [
        {
            "nombre": "Mateo Rossi",
            "profesion": "Arquitecto",
            "testimonio": "Como arquitecto, valoro muchísimo el diseño y la durabilidad. Compré una correa de cuero reforzado y un pretal ergonómico para mi Border Collie; la calidad de las terminaciones es impecable y aguanta perfectamente los tirones cuando paseamos por los parques de Palermo. Se nota que usan materiales de primera y no algo descartable.",
            "img": mateo
        },
        {
            "nombre": "Florencia Giménez",
            "profesion": "Docente",
            "testimonio": "Mis gatos son parte de mi familia y muy exigentes con la comida. Desde que pido el alimento balanceado premium por acá, no solo me ahorro el viaje cargando bolsas pesadas, sino que el pelaje de los tres mejoró muchísimo. El servicio de entrega es súper puntual, algo fundamental para alguien que vive con los horarios justos de la escuela.",
            "img": florencia
        },
        {
            "nombre": "Santiago Luján",
            "profesion": "Contador",
            "testimonio": "Estaba cansado de que mis gatas destruyeran el sillón del living, que todavía estoy pagando. Compré un rascador de tres niveles con plataformas de descanso y fue un cambio total de vida. Ahora pasan horas ahí arriba mirando por la ventana. La estructura es firme, fácil de armar y estéticamente queda muy bien en el departamento.",
            "img": santiago
        },
        {
            "nombre": "Lucía Fernández",
            "profesion": "Diseñadora",
            "testimonio": "Trabajo haciendo home office y mi caniche demandaba atención constante. Los juguetes interactivos y los dispensadores de snacks que conseguí son geniales; la mantienen entretenida y estimulada mentalmente mientras yo estoy en reuniones de Zoom. Son seguros, fáciles de lavar y se nota que están pensados para el bienestar animal.",
            "img": lucia
        },
        {
            "nombre": "Matias Herrera",
            "profesion": "Cocinero",
            "testimonio": "Tengo un ovejero alemán ya mayor que sufría mucho el frío del piso en invierno. La cama térmica que adquirí es una maravilla; mantiene una temperatura constante y suave que lo ayuda con sus dolores de cadera. Verlo descansar profundamente sin quejarse me da una tranquilidad enorme. Es, sin duda, la mejor inversión que hice este año.",
            "img": matias
        }
    ]

export const CONTACTOS = [
    {
        nombre: 'Direccion',
        descripcion: "Argentina - Buenos Aires",
        url: ''
    },
    {
        nombre: 'Telefono',
        descripcion: "000",
        url: ''
    },
    {
        nombre: 'Correo',
        descripcion: "ventas@petsupplies.com.ar",
        url: ''
    },
]